export default "__VITE_ASSET__Dkutsgyx__"